export default {
  LP_PX_TAM: 1000,
  LP_PX_TAM_MOBILE: 412,
  TOKEN_JWT_PREFIX: "AUTH_TOKEN",
};
